import React from 'react';
import { useLabels } from 'wsm-common-data';

const NoResultsHeader = () => {
	const labels = useLabels();
	const noresultText = labels.get('DROPDOWN_NO_RESULTS');

	return (
		<div className="mb-4">
			<h2 className="display-4 text-center font-weight-bold divider-centered-border-bottom divider-primary divider-2 my-4">
				{noresultText}
			</h2>
		</div>
	);
};

export default NoResultsHeader;
